function ArrowLeftLong({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.639532 10.9393C0.0537453 11.5251 0.0537453 12.4749 0.639532 13.0607L10.1855 22.6066C10.7713 23.1924 11.721 23.1924 12.3068 22.6066C12.8926 22.0208 12.8926 21.0711 12.3068 20.4853L3.82151 12L12.3068 3.51472C12.8926 2.92893 12.8926 1.97919 12.3068 1.3934C11.721 0.807611 10.7713 0.807611 10.1855 1.3934L0.639532 10.9393ZM29.7002 10.5L1.70019 10.5V13.5L29.7002 13.5V10.5Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default ArrowLeftLong;
